"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { Tooltip } from '../Tooltip/index.mjs';
import useEventStopPropagation from '../../helpers/hooks/useEventStopPropagation.mjs';
import '../DataBuilderUI/FieldControlPanel/index.mjs';
import '../DataBuilderUI/ActionBar.mjs';
import { CellButton } from '../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../DataBuilderUI/styles.module.css.mjs';
import '../DataBuilderUI/Row.mjs';
import '../DataBuilderUI/Title.mjs';

function FieldDelete({ onClick }) {
  const handleClick = useEventStopPropagation(onClick);
  if (!onClick) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tooltip, { tooltip: "Delete", usePortal: true, children: /* @__PURE__ */ jsx(CellButton, { type: "icon", icon: SvgIconType.Close, onClick: handleClick, "aria-label": "Delete" }) });
}

export { FieldDelete };
